import { Capacitor } from '@capacitor/core';
import packageJson from "../../package.json";


export const isWeb = () => {
  // return Capacitor.getPlatform() === 'web';
  // console.log(packageJson.app_website);
  // console.log((packageJson as any).appwebsite === "website");
  return (packageJson as any).appwebsite === "website";

};

export const isMobile = () => {
  const platform = Capacitor.getPlatform();
  return platform === 'ios' || platform === 'android';
};

// Detect if it's a larger screen (desktop/tablet)
export const isDesktop = () => {
  return isWeb();
  // return isWeb() && window.innerWidth >= 768;
};
